// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0d8cb7ca","247":"4421985f","284":"5c269413","551":"0e75fa46","627":"8b47c7e4","738":"2abee493","768":"40fdebcb","834":"bbb765f4","842":"b095d066","923":"4a443fe6","938":"8cff4698"}[chunkId] + ".chunk.js";
};